import { datadogLogs } from '@datadog/browser-logs'
import { getParams } from './helpers'

class ApiError extends Error {
	constructor(message: string, protected status: string, name: string) {
		super(message)
		this.name = name
	}
}

type loggerInfoProps = {
	data: any
	context: 'survey' | 'appointment-confirmation' | 'payment-checkout'
	location?: string | undefined
	payloadRequest?: any
	uuid?: string | undefined
	type?: 'info' | 'error'
}

const COMMOM_ERRORS = [400, 401, 403, 404, 500, 501, 502, 503, 504]

export const loggerInfo = ({
	data,
	context,
	location,
	payloadRequest,
	uuid,
	type = 'error',
}: loggerInfoProps) => {
	const { id, token }: any = getParams()
	const payload = {
		uuid: uuid,
		context,
		browserDate: new Date().toISOString(),
		user: { userId: id, userToken: token },
		error: data?.response ? data.response.data : data,
		name: location,
		message: data?.message || '',
		payloadRequest: payloadRequest || '',
	}

	if (type === 'info') {
		datadogLogs.logger.info(context, { ...payload })
		return
	}

	if (data?.response?.status && COMMOM_ERRORS.includes(data.response.status)) {
		const errorCode = data.response.status
		const error = new ApiError(payload.message, errorCode, data?.code)
		datadogLogs.logger.error(context, { ...payload }, error)
		return
	}

	datadogLogs.logger.error(context, { ...payload })
}
